<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w max-gl" id="page-content-main">
    <!-- <epay-lib-common-forgotusername [baseurl]="baseurl">
    </epay-lib-common-forgotusername> -->

    <forgot-username-common [baseurl]="baseurl"></forgot-username-common>
  </div>
</epay-page-content>
